import {
  Box,
  MenuItem,
  Paper,
  SelectChangeEvent,
  Tab,
  Tabs,
} from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';

import { PersitedDatePicker } from '../../../components/common';
import { AddButton } from '../../../components/common/button/CustomButtons';
import ModalCustom from '../../../components/common/Modal';
import { SupervisorPartTable } from '../../../components/ui';
import ChildHeader from '../../../components/ui/ChildHeader';
import { useQuery } from '../../../hooks/UseQuery';
import { useAuth } from '../../../services/auth/AuthProvider';
import DefectWise from './components/dashboard/DefectWiseQty/DefectWiseQty';
import PartWise from './components/dashboard/partWiseQty/PartWiseQty';
import GridInputs from '../../../components/common/inputs/GridInputs';
import CustomSelect from '../../../components/common/SelectField';

const RejectionAnalysisDashboardTabs = () => {
  const annual_month = useQuery('annual_date') || '';
  const [tabValue, setTabValue] = useState(0);
  const [defects, setDefects] = useState<any>({});
  const [partsDateWise, setPartsDateWise] = useState<any>({});

  const fetchData = async () => {
    if (annual_month) {
      if (tabValue === 0) {
        const res = await axios
          .get(
            `/api/redBinMonitoringSheet/dashboard/getByDateWise/?annualMonth=${annual_month}`,
          )
          .catch((err) => {
            console.log(err);
          });
        setPartsDateWise(res?.data);
      } else {
        const res = await axios
          .get(
            `/api/redBinMonitoringSheet/dashboard/getByDefectWise/?annualMonth=${annual_month}`,
          )
          .catch((err) => {
            console.log(err);
          });
        setDefects(res?.data);
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, [tabValue]);
  return (
    <Box>
      <ChildHeader text="RED BIN MONITORING REJECTION DASHBOARD"></ChildHeader>
      <Paper elevation={2}>
        <Tabs
          value={tabValue}
          onChange={(_, newValue) => setTabValue(+newValue)}
          indicatorColor="primary"
          scrollButtons="auto"
          textColor="secondary"
          variant="fullWidth"
        >
          <Tab label="Monthly Data Date Wise" />
          <Tab label="Monthly data Defect Wise" />
          <Tab label="Top 10 Part Wise Rejection Data" />
          <Tab label="Part Wise Rejection Data" />
        </Tabs>
      </Paper>
      <section>
        {tabValue === 0 && partsDateWise && partsDateWise?.dateWise && (
          <PartWise apiData={partsDateWise?.dateWise} />
        )}
        {tabValue === 1 && defects && defects?.defectWise && (
          <DefectWise
            apiData={defects?.defectWise}
            title1="DEFECT WISE PARETO ANALYSIS"
          />
        )}
        {tabValue === 2 && defects && defects?.defectWise && (
          <DefectWise
            apiData={defects?.defectWise}
            top20={true}
            title1="PARETO CHART - TOP 10 PARTS"
            title2="Top 10 PART REJECTION TREND"
          />
        )}
        {tabValue === 3 && defects && defects?.defectWise && (
          <DefectWise
            apiData={defects?.defectWise}
            allPart={true}
            title2="PART REJECTION TREND"
          />
        )}
      </section>
    </Box>
  );
};

export default RejectionAnalysisDashboardTabs;
